export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-geo/src/identity.js
// module id = s9yc
// module chunks = 0